// extracted by mini-css-extract-plugin
export default {"AboutT":"AboutT_AboutT__W1jlC","svg":"AboutT_svg__j0SHW","title":"AboutT_title__FipTk","item":"AboutT_item__BKDIg","text":"AboutT_text__83At4","button":"AboutT_button__hSdm6"};